import HomeBody from "../Componentes/HomeBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";

import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

import { AuthContext } from "../Auth/AuthProvider";
import { VerifyPermission } from "../Funcoes/VerifyPermission";

const NewHome = ({ modulo }) => {

    const { user } = useContext(AuthContext);

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [loadingRelat, setLoadingRelat] = useState(false);

    const [overlay, setOverlay] = useState(false);

    const [colabs, setColabs] = useState([]);
    const [colabsFilter, setColabsFilter] = useState([]);

    const funcoes = [...new Set(colabs.map(item => item.FUNCAO).filter(FUNCAO => FUNCAO).sort())]
    const obras = [...new Set(colabs.map(item => item.CENTRO_CUSTO).filter(CENTRO_CUSTO => CENTRO_CUSTO).sort())]
    const encarregados = [...new Set(colabs.map(item => item.ENCARREGADO).filter(ENCARREGADO => ENCARREGADO).sort())]
    const contratos = [...new Set(colabs.map(item => item.CONTRATO).filter(CONTRATO => CONTRATO).sort())]

    const filterDados = useCallback((filterName, filterMat, filterFunc, filterEnc, filterObra, filterCont, filterStatus, filterMaoObra) => {

        const filtered = colabs.filter(item => {

            const name_filter = !filterName || item.NOME.toUpperCase().includes(filterName.toUpperCase());
            const mat_filter = !filterMat || item.MATRICULA.includes(filterMat)

            const func_filter = filterFunc.length === 0 || filterFunc.some(func => item.FUNCAO.includes(func.value));
            const enc_filter = filterEnc.length === 0 || filterEnc.some(enc => (item.ENCARREGADO || '').includes(enc.value));
            const obra_filter = filterObra.length === 0 || filterObra.some(obra => item.CENTRO_CUSTO.includes(obra.value));
            const cont_filter = filterCont.length === 0 || filterCont.some(cont => (item.CONTRATO || '').includes(cont.value));
            const stat_filter = filterStatus.length === 0 || filterStatus.some(stat => item.STATUS.includes(stat.value));
            const mao_filter = filterMaoObra.length === 0 || filterMaoObra.some(mao => item.MAOOBRA.includes(mao.value));

            return name_filter && mat_filter && func_filter && enc_filter && obra_filter && cont_filter && stat_filter && mao_filter;

        })

        setColabsFilter(filtered);

    }, [colabs])

    useEffect(() => {

        setLoading(true);

        const getColabs = async () => {

            try {

                const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/GetHomeColabs/');

                setColabs(data);
                setColabsFilter(data);

            } catch (error) {

                console.log(error);

            } finally {

                setLoading(false);

            }

        }

        getColabs();

    }, [])

    const generateRPE = async () => {

        setLoadingRelat(true);

        try {

            console.log(colabsFilter)

            const response = await axios.post(
                'https://sistemaintegrado.palmont.com.br/Painel/API/GenerateNewRelatorio/', colabsFilter,
                {
                    responseType: 'blob',
                    withCredentials: true
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'relatorio.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {

            console.error("Erro ao gerar o relatório:", error);
            alert("Ocorreu um erro ao gerar o relatório. Por favor, tente novamente.");

        } finally {

            setLoadingRelat(false);

        }

    }

    const showOverlay = () => {

        setOverlay(true);

    }

    const handleClick = (to, permission) => {

        if (permission) {

            navigate(to);

        } else {

            toast.error('Você não possui permissão para acessar esse módulo')

        }

    }

    const menuItems = [
        {
            label: "AUDITORIA INTERNA",
            path: "/modulo/ssma/auditoria-interna",
            permission: { modulo: "ssma", submodulo: "auditoria-interna", funcao: "access" }
        },
        {
            label: "ATENDIMENTO AMBULAT.",
            external: "https://sistemaintegrado.palmont.com.br/Painel/AtendimentoAmb/",
            permission: { modulo: "ssma", submodulo: "atendimento-amb", funcao: "access" }
        },
        {
            label: "CHECK-LIST",
            path: "/modulo/ssma/check-list",
            permission: { modulo: "ssma", submodulo: "check-list", funcao: "access" }
        },
        {
            label: "CIPA",
            path: "/modulo/ssma/cipa",
            permission: { modulo: "ssma", submodulo: "cipa", funcao: "access" }
        },
        {
            label: "DDS",
            path: "/modulo/ssma/dds",
            permission: { modulo: "ssma", submodulo: "dds", funcao: "access" }
        },
        {
            label: "DESVIOS",
            path: "/modulo/ssma/desvios",
            permission: { modulo: "ssma", submodulo: "desvios", funcao: "access" }
        },
        {
            label: "EPI-CONTROLE",
            path: "/modulo/ssma/epi",
            permission: { modulo: "ssma", submodulo: "epi", funcao: "access" }
        },
        {
            label: "INSPEÇÃO DE SST",
            external: "https://sistemaintegrado.palmont.com.br/Painel/Inspecao/",
            permission: { modulo: "ssma", submodulo: "inspecao-sst", funcao: "access" }
        },
        {
            label: "INSPEÇÃO AMBIENTAL",
            external: "https://sistemaintegrado.palmont.com.br/Painel/InspecaoMA/",
            permission: { modulo: "ssma", submodulo: "inspecao-ambiental", funcao: "access" }
        },
        {
            label: "PAINEL DE CONTROLE",
            path: "/modulo/ssma/painel-ctrl",
            permission: { modulo: "ssma", submodulo: "painel-ctrl", funcao: "access" }
        },
        {
            label: "RAC",
            path: "/modulo/ssma/rac",
            permission: { modulo: "ssma", submodulo: "rac", funcao: "access" }
        },
        {
            label: "TREINAMENTOS",
            path: "/modulo/ssma/treinamentos",
            permission: { modulo: "ssma", submodulo: "treinamentos", funcao: "access" }
        },
        {
            label: "AFASTAMENTOS",
            path: "/modulo/rh/afastamentos",
            permission: { modulo: "rh", submodulo: "afastamentos", funcao: "access" }
        },
        {
            label: "ATENDIMENTOS",
            external: "https://sistemaintegrado.palmont.com.br/Painel/Atendimento/",
            permission: { modulo: "rh", submodulo: "atendimentos", funcao: "access" }
        },
        {
            label: "CONTROLE DE EXPERIÊNCIA",
            path: "/modulo/rh/controle-exp",
            permission: { modulo: "rh", submodulo: "controle-exp", funcao: "access" }
        },
        {
            label: "EXAMES OCUPACIONAIS",
            path: "/modulo/rh/exames-ocupa",
            permission: { modulo: "rh", submodulo: "exames-ocupa", funcao: "access" }
        },
        {
            label: "GER. FOLGAS",
            path: "/modulo/rh/ger-folgas",
            permission: { modulo: "rh", submodulo: "ger-folgas", funcao: "access" }
        },
        {
            label: "FOLHA DE PAGAMENTO",
            path: "/modulo/rh/folha-pag",
            permission: { modulo: "rh", submodulo: "folha-pag", funcao: "access" }
        },
        {
            label: "PROCESSO ADM/TRANSF",
            path: "/modulo/rh/processo-adm",
            permission: { modulo: "rh", submodulo: "processo-adm", funcao: "access" }
        },
        {
            label: "REPUBLICAS",
            path: "/modulo/rh/republicas",
            permission: { modulo: "rh", submodulo: "republicas", funcao: "access" }
        },
        {
            label: "GERAR RELATÓRIO",
            action: generateRPE,
            isLoading: loadingRelat
        },
        {
            label: "ORGANOGRAMA COLABS",
            path: "/modulo/rh/organograma-colabs",
            permission: { modulo: "rh", submodulo: "organograma", funcao: "access" }
        },
        {
            label: "ORGANOGRAMA COLABS",
            path: "/modulo/ssma/organograma-colabs",
            permission: { modulo: "ssma", submodulo: "organograma", funcao: "access" }
        },
        {
            label: "ORGANOGRAMA COLABS",
            path: "/modulo/qualidade/organograma-colabs",
            permission: { modulo: "qualidade", submodulo: "organograma", funcao: "access" }
        },
        {
            label: "CALIB. EQUIPAMENTOS",
            path: "/modulo/qualidade/equip-calibragem",
            permission: { modulo: "qualidade", submodulo: "equip-calibragem", funcao: "access" }
        }
    ];

    const filteredMenuItems = menuItems.filter((item) => {

        if (!item.permission) {
            return true;
        }
    
        const sameModulo = item.permission.modulo === modulo;
        const hasPermission = VerifyPermission(user, item.permission);
    
        return sameModulo && hasPermission;
    });

    const orderedMenuItems = filteredMenuItems.sort((a, b) =>
        a.label.localeCompare(b.label)
    );

    return (
        <>
            <NavBar
                title="HOME"
                changeState={showOverlay}
            />
            <HomeBody
                dados={colabsFilter}
                funcoes={funcoes}
                obras={obras}
                encarregados={encarregados}
                contratos={contratos}
                onFilter={filterDados}
                loading={loading}
                modulo={ modulo }
            />
            <Overlay
                state={overlay}
                changeState={setOverlay}
            >
                <SideMenu>
                    {
                        orderedMenuItems.map(( item ) => (

                            <SideMenuBtn
                                key={ item.label }
                                button={ item.label }
                                isLoading={ item.isLoading }
                                clickFunc={() => {

                                    if( item.external ){

                                        window.location.href = item.external;
                                        
                                    }else if( item.action ){

                                        item.action();

                                    }else if( item.path ){

                                        handleClick( item.path, true )

                                    }

                                }}
                            />
                        ))
                    }
                </SideMenu>
            </Overlay>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                style={{
                    zIndex: '99999'
                }}
            />
        </>
    );
}

export default NewHome;